<template>
  <div class="limiter">
    <div class="container-login100">
      <div class="wrap-login100" :class="{ 'uk-animation-shake': shakeForm }">
        <form class="login100-form validate-form" @submit.prevent="onSubmit">
          <span class="login100-form-title p-b-26">
            <img src="../assets/patchboard-logo.png">
          </span>
          <span class="login100-form-title p-b-48">
            Reset Password
          </span>

          <div class="wrap-input100">
            <div class="input-underline">
              <input name="newPassword" v-focus="true"
                class="input100"
                type="password"
                :class="{'has-val': newPassword, 'has-error': errors.has('newPassword')}"
                v-model="newPassword"
                v-validate="{ required: true, min: 6 }">
              <span class="focus-input100" data-placeholder="New Password"></span>
            </div>
            <div v-show="errors.has('newPassword')" class="uk-text-danger">{{ errors.first('newPassword') }}</div>
          </div>

          <div class="wrap-input100">
            <div class="input-underline">
              <input name="newPasswordConfirm"
                class="input100"
                type="password"
                :class="{'has-val': newPasswordConfirm, 'has-error': errors.has('newPasswordConfirm')}"
                v-model="newPasswordConfirm"
                v-validate="{ required: true, min: 6 }">
              <span class="focus-input100" data-placeholder="Confirm New Password"></span>
            </div>
            <div v-show="errors.has('newPasswordConfirm')" class="uk-text-danger">{{ errors.first('newPasswordConfirm') }}</div>
          </div>

          <div class="text-center">
            <span class="txt1">
              {{errorMessage}}
            </span>
          </div>

          <button :disabled="submitting"
            class="uk-button uk-button-primary uk-width-1 uk-margin-top"
            v-html="submitting ? 'Please Wait...' : 'Change Password'"></button>

          <div class="text-center">
            <router-link class="txt2" :to="`/login`">Remembered your password?</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      newPassword: '',
      newPasswordConfirm: '',
      shakeForm: false,
      submitting: false,
      errorMessage: ''
    };
  },
  methods: {
    onSubmit(e) {
      if (this.submitting) return;
      this.errorMessage = '';
      this.submitting = true;

      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.submitting = false;
          this.shakeForm = true;
          setTimeout(() => { this.shakeForm = false; }, 1000);
          return;
        }

        this.changePassword({
          authorizer: {
            token: this.$route.query.token,
            user_id: this.$route.query.user_id
          },
          newPassword: this.newPassword,
          newPasswordConfirm: this.newPasswordConfirm
        }).then((response) => {
          this.$router.push({ name: 'home' });
        }).catch((error) => {
          this.errorMessage = error.response ? error.response.data : error.message;
        }).then(() => {
          this.submitting = false;
        });
      });
    },
    ...mapActions([
      'changePassword'
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue